import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=c4f527ee&scoped=true&"
import script from "./Shape.vue?vue&type=script&lang=js&"
export * from "./Shape.vue?vue&type=script&lang=js&"
import style0 from "./Shape.vue?vue&type=style&index=0&id=c4f527ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f527ee",
  null
  
)

export default component.exports